<template>
  <div class="mmain" v-title data-title="北京天蔚中医药发展促进中心-项目展示">
    <div class="program">
      <div
        @click="$router.push(`/mProgramContent/${item.id}`)"
        class="pWrapper"
        :data-before="item.name"
        v-for="(item, index) in pnav"
        :key="item.id"
      >
        <img :src="item.picture" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getProgram } from "@/api/product.js";
import { BASE_URL } from "@/utils/base.js";
import Bus from "@/utils/bus.js";
export default {
  name: "Home",
  data() {
    return {
      pnav: [],
      programData: {},
    };
  },
  created() {
    this.getProgram();
  },
  mounted() {
    window.scrollTo({
      top: 0,
    });
    this.$nextTick(function () {
      Bus.$emit("getpCurrent", "mprogram");
    });
  },
  methods: {
    // 获取项目
    async getProgram() {
      let program = await getProgram();
      this.pnav = program.filter((item) => {
        item.itemtime = item.itemtime.substring(0, 10);
        return (item.picture = BASE_URL + item.picture);
      });
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
  margin-top: 150px;
  padding: 20px 0 80px;
  background-color: #ebebeb;
  .program {
    width: calc(100vw - 60px);
    margin: 0 auto;
    .pWrapper {
      margin-top: 20px;
      position: relative;

      img {
        width: 100%;
        height: 300px;
      }
      &::before {
        content: "";
        color: #fff;
        position: absolute;
        bottom: 0px;
        left: 0px;
        line-height: 80px;
        padding-left: 50px;
        width: calc(100% - 50px);
        height: 80px;
        background-image: linear-gradient(to right, #000, #666, #ccc);
        // background-color: rgba(0, 0, 0, .3);
        opacity: .8;
        z-index: 50;
      }
      &::after {
        content: attr(data-before);
        color: #fff;
        position: absolute;
        bottom: 0px;
        left: 0px;
        line-height: 80px;
        padding-left: 50px;
        height: 80px;
        font-size: 30px;
        z-index: 50;
      }
    }
  }
}
</style>